module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: ('back-add-person'),
      expression: "'back-add-person'"
    }],
    staticClass: "z-add-person"
  }, [_c('div', {
    staticClass: "double-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.name)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("账号")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.account)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("工号")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.job_num)) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("入职时间")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.work_date)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("出生日期")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.birth_date)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.phone_num)) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("职位属性")]), _vm._v(" "), _c('div', {
    staticClass: "double-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("岗位")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.position_name)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("职级")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.sub.rank)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("所属BU")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_c('div', [_vm._v(_vm._s(_vm._f("empty")(_vm.bu_name)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("角色")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("empty")(_vm.role_names)) + "\n                    ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-408f18cb!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/person-detail/tab/personInfo-read.vue
// module id = 731
// module chunks = 1